module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img16.c9635172.jpg";